const CustomWebView = require('../../src/js/client/components/WebView').default;

exports._webview = CustomWebView;
